import {makeDefaultEmpty} from '../../components/DefaultEmpty';
export const collectionsComponentsMap = {
    CustomActionPanelCollectionActions: makeDefaultEmpty<{}>(),
    RootCollectionTitleAction: makeDefaultEmpty<{}>(),
} as const;
